var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCsvTableHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000065776992484632746770000009072479731728926081_);}\r\n\t.st1{fill:currentColor;transition:fill var(--amplify-components-button-transition-duration);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_56",
    transform: "translate(-996 -1134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18",
    transform: "translate(996 1134)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116917076438099557980000008731812244763768977_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17",
    style: {
      clipPath: "url(#SVGID_00000116917076438099557980000008731812244763768977_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    className: "st1",
    d: "M12,18l-7.5-7.5l2.1-2.18l3.9,3.9V0h3v12.23l3.9-3.9l2.1,2.17L12,18z M3,24 c-0.8,0.01-1.56-0.31-2.12-0.88C0.31,22.56-0.01,21.8,0,21v-4.5h3V21h18v-4.5h3V21c0,1.66-1.34,3-3,3H3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCsvTableHover);
export default __webpack_public_path__ + "static/media/ico_csv_table_hover.1f62adb64c56b0344969be054d036adf.svg";
export { ForwardRef as ReactComponent };